import './divider.modules.scss';

const Divider = () => {
    return <hr className="divider" />;
};

export default Divider;
